import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { Tooltip, DatePicker, Select } from "antd";
import moment from "moment";
import { Link, useLocation } from "react-router-dom";
import { paginate } from "../../../utlits/Paginate.js";
import Pagination from "../../Reuseable/Pagination";
import AddLeaves from "./AddLeaves";
import secureLocalStorage from "react-secure-storage";
import LeaveEntitlementService from "../../../Services/LeaveEntitlementService";
import DataParser from "../../../utlits/Dataparser";
import LeaveApplicationService from "../../../Services/LeaveApplicationService";
import shortid from "shortid";
import LeaveBadge from "../../Reuseable/LeaveBadge";
import PhyicalYearService from "../../../Services/PhyicalYearService";
import LeavetypeService from "../../../Services/PolicyServices";
import SocketService from "../../../Services/SocketService";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import TableSkeleton from "../../Reuseable/TableSkeleton";

const Leaves = () => {
  const { RangePicker } = DatePicker;
  const { Option } = Select;
  const location = useLocation();
  const adminInfo = JSON.parse(secureLocalStorage.getItem("adminInfo"));
  const role = adminInfo?.user?.userdata?.role_title;

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [DataForEmployee, setDataForEmployee] = useState([]);
  const [isloading, setLoading] = useState(false);
  const [reasonText, setReasonText] = useState("");
  const [leavetypeText, setLeaveTypeText] = useState("");
  const [fromdateText, setfromdateText] = useState("");
  const [todateText, settodateText] = useState("");
  const [noofdaysText, setnoofdaysText] = useState("");
  const [allowedleavesText, setallowedleavesText] = useState("");
  const [leavebalanceText, setleavebalanceText] = useState("");
  const [statusText, setstatusText] = useState("");
  const [actiontakenbyText, setactiontakenbyText] = useState("");


  const [searchValue, setSearchValue] = useState("");

  const [dateRangeFilter, setDateRangeFilter] = useState(null);
  const [statusFilter, setStatusFilter] = useState("all");

  // Serach states
  const [userEntitlementList, setUserEntitlementsList] = useState([]);
  const [leavePolicyList, setLeavePolicyList] = useState([]);
  const [userLeavesList, setUserLeavesList] = useState([]);
  const [leaveBalances, setLeaveBalances] = useState([]);
  const [absentCount, setAbsentCount] = useState(0);

  const [sessionId, setSessionId] = useState("");

  const [leavesession, setLeaveSession] = useState("");

  const [userLeaveCheck, setUserLeavesCheck] = useState("");
  const [employeeName, setEmployeeName] = useState("");
  const [leaveType, setLeaveType] = useState("");
  const [leaveStatus, setLeaveStatus] = useState("");
  const [leaveFrom, setLeaveFrom] = useState("");
  const [leaveTo, setLeaveTo] = useState("");
  const compid = DataParser.CompanyId();
  const userid = DataParser.UserId();

  const getUserEntitlements = (u, c) => {
    LeaveEntitlementService.userLeaveEntitlement(u, c)
      .then((res) => {
        const Data = res.data[0].leavePolicy;
        setLeavePolicyList(Data);
      })
      .catch((err) => {
        console.error("Error fetching entitlements:", err);
        setLeavePolicyList([]);
      });
  };

  const getPhysicalPeriodDetails = (id) => {
    PhyicalYearService.getPhysicalYearDetails(id)
      .then((res) => {
        const data = res.data;
        setSessionId(data.id);
      })
      .catch((err) => {
        console.error("Error fetching physical period details:", err);
      });
  };

  const getPhyiscalYear = (c) => {
    PhyicalYearService.getPhysicalYear(c)
      .then((res) => {
        const data = res.data.Settings[0].id;
        setLeaveSession(data);
      })
      .catch((err) => {
        console.error("Error fetching physical year:", err);
      });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        const phyicalRes = await PhyicalYearService.getPhysicalYear(compid);
        const data = phyicalRes?.data?.Settings?.[0]?.id;
        setLeaveSession(data);

        let userIdToFetch, body;
        if (location?.state?.data) {
          userIdToFetch = location.state.data;
        } else {
          userIdToFetch = userid;
        }

        body = {
          company_id: compid,
          leavesession: data,
        };

        const [leaveAppsRes, entitlementsRes] = await Promise.all([
          LeaveApplicationService.getLeaveApplicationUser(userIdToFetch, compid),
          LeaveEntitlementService.userLeaveEntitlement(userIdToFetch, body),
        ]);

        const leaveData = leaveAppsRes?.data?.leave_applications || [];
        const uniqueData = Array.from(new Map(leaveData.map(item => [item.id, item])).values());
        const entitlements = entitlementsRes?.data?.[0]?.leavePolicy || [];

        setDataForEmployee(uniqueData);
        setLeavePolicyList(entitlements);
      } catch (err) {
        console.error("Error loading data:", err);
        setDataForEmployee([]);
        setLeavePolicyList([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();

    LeavetypeService.getUserLeavePolicy(compid, userid)
      .then((res) => {
        if (res?.success) {
          setLeaveBalances(res.data || []);
          setAbsentCount(res.absent_count || 0);
        } else if (Array.isArray(res)) {
          setLeaveBalances(res);
        } else {
          setLeaveBalances([]);
        }
      })
      .catch((err) => console.error("Error fetching leave balances:", err));
  }, []);

  useEffect(() => {
    SocketService.connect();

    const handleLeaveUpdate = (data) => {
      if (String(data.company_id) === String(compid)) {
        const targetEmpId = location.state ? location.state.data : userid;
        if (String(data.user_id) === String(targetEmpId)) {
          getLeaveApplicationsAll(targetEmpId, compid);
          if (leavesession) {
            getUserEntitlements(targetEmpId, { company_id: compid, leavesession: leavesession });
          }
          LeavetypeService.getUserLeavePolicy(compid, targetEmpId)
            .then((res) => {
              if (Array.isArray(res.data)) {
                setLeaveBalances(res.data);
              } else if (res.data?.success && Array.isArray(res.data.data)) {
                setLeaveBalances(res.data.data);
              } else {
                setLeaveBalances([]);
              }
            })
            .catch((err) => console.error("Error refreshing leave balances:", err));
        }
      }
    };

    SocketService.on("leave_update", handleLeaveUpdate);

    return () => {
      SocketService.off("leave_update", handleLeaveUpdate);
    };
  }, [compid, userid, leavesession]);

  useEffect(() => {
    if (pageSize > 15) {
      setCurrentPage(1);
    }
  }, [pageSize]);

  const handelPageChange = (e, page) => {
    e.preventDefault();
    setCurrentPage(page);
  };

  const getLeaveApplicationsAll = (u, c) => {
    setLoading(true);
    LeaveApplicationService.getLeaveApplicationUser(u, c)
      .then((res) => {
        const data = res?.data?.leave_applications || [];
        const uniqueData = Array.from(new Map(data.map(item => [item.id, item])).values());
        setDataForEmployee(uniqueData);
      })
      .catch((error) => {
        console.error("Error fetching leave applications:", error);
        setDataForEmployee([]);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const checkLeaves = (e, item) => {
    e.preventDefault();
    LeaveApplicationService.userLeaveByApplication(item.id, compid)
      .then((res) => {
        const datas = res.data.userLeaves;
        setUserLeavesList(datas);
      })
      .catch((err) => {
        console.error("Error checking leaves:", err);
        setUserLeavesList([]);
      });
  };

  const handleViewReason = (reason, leav_type, from_date, to_date, totalleaves, allowed_leaves, remaining_leaves, status, approved_by, leavedates) => {
    setReasonText(reason || "No reason provided");
    setLeaveTypeText(leav_type || "")

    let finalFrom = from_date;
    let finalTo = to_date;
    if ((!from_date || from_date === "N/A" || !moment(from_date).isValid()) && leavedates && leavedates[0]) {
      const m = moment(leavedates[0], "DD-MM");
      if (m.isValid()) finalFrom = m.format("YYYY-MM-DD");
    }
    if ((!to_date || to_date === "N/A" || !moment(to_date).isValid()) && leavedates && leavedates[0]) {
      const m = moment(leavedates[0], "DD-MM");
      if (m.isValid()) finalTo = m.format("YYYY-MM-DD");
    }

    if (finalFrom === "Invalid date") finalFrom = "N/A";
    if (finalTo === "Invalid date") finalTo = "N/A";

    setfromdateText(finalFrom || "N/A");
    settodateText(finalTo || "N/A");
    setnoofdaysText(totalleaves || null)

    if (leav_type === "Absent Penalty" || leav_type === "Absent") {
      setallowedleavesText("N/A");
      setleavebalanceText("N/A");
    } else {
      setallowedleavesText(allowed_leaves || null);
      setleavebalanceText(remaining_leaves || null);
    }

    setstatusText(status || "");
    setactiontakenbyText((status === 3 || status === 4) ? "System" : (approved_by || ""));
    const modal = new window.bootstrap.Modal(
      document.getElementById("reasonModal")
    );
    modal.show();
  };

  const getFilteredData = () => {
    let filtered = [...DataForEmployee];
    if (dateRangeFilter && dateRangeFilter.length === 2) {
      const [start, end] = dateRangeFilter;
      filtered = filtered.filter(item => {
        const itemStartDate = moment(item.from_date);
        const itemEndDate = moment(item.to_date);
        return (
          (itemStartDate.isSameOrAfter(start, 'day') && itemStartDate.isSameOrBefore(end, 'day')) ||
          (itemEndDate.isSameOrAfter(start, 'day') && itemEndDate.isSameOrBefore(end, 'day')) ||
          (itemStartDate.isBefore(start, 'day') && itemEndDate.isAfter(end, 'day'))
        );
      });
    }
    if (statusFilter !== "all") {
      filtered = filtered.filter(item => String(item.status) === statusFilter);
    }
    return filtered;
  };

  const filteredData = getFilteredData();
  const PaginatedData = paginate(filteredData, currentPage, pageSize);

  return (
    <>
      <Helmet>
        <title>My Leaves Request - Planit</title>
      </Helmet>
      <AddLeaves
        id={"offcanvasRightLeaves"}
        sessionId={sessionId}
        labelledby={"offcanvasRightLeavesLabel"}
        userLeaveCheck={userLeaveCheck}
        getLeaveApplicationsAll={getLeaveApplicationsAll}
        location={location}
      />
      <div className="main-content">
        <div className="page-content Pagebody" style={{ backgroundColor: "#fff", minHeight: "100vh" }}>
          <div className="container-fluid">
            <div className="row">
              <div className="col-12 px-0">
                <style>{`
                    .card, .card-body, .table-responsive, .listing-table-wrapper, 
                    .listing-table, .listing-table thead, .listing-table tr, 
                    .listing-table th, .listing-table td {
                        border-radius: 0 !important;
                        box-shadow: none !important;
                        border-left: none !important;
                        border-right: none !important;
                        border-top: none !important;
                    }
                    .listing-table thead tr.tableHeaderbg th {
                        background-color: #F2F2F2 !important;
                        color: #212529 !important;
                        border-bottom: none !important;
                        font-weight: 600 !important;
                        font-size: 13px !important;
                        padding: 8px 12px !important;
                    }
                    .listing-table tbody tr td { border-bottom: 1px solid #F2F2F2 !important; vertical-align: middle !important; }
                    .listing-table tbody tr:last-child td { border-bottom: none !important; }
                    .custom-filter.float-select-wrap .ant-select-selector,
                    .custom-filter.float-select-wrap .ant-picker {
                        height: 34px !important;
                        min-height: 34px !important;
                        border-radius: 6px !important;
                    }
                    .custom-filter.float-select-wrap .ant-select-selection-item,
                    .custom-filter.float-select-wrap .ant-select-selection-placeholder,
                    .custom-filter.float-select-wrap .ant-picker-input > input { line-height: 30px !important; font-size: 13px !important; }
                    .custom-filter.float-select-wrap label { font-size: 11px !important; font-weight: 600 !important; }
                    .ant-picker-range .ant-picker-active-bar { background: #1D1D1D !important; }
                    .eval-action-btn {
                        height: 34px !important; border-radius: 6px !important; font-size: 13px !important; font-weight: 600 !important;
                        padding: 0 15px !important; display: flex !important; align-items: center !important; justify-content: center !important;
                        background-color: #0DDFAB !important; border: 1px solid #0DDFAB !important; color: white !important;
                    }
                    .eval-action-btn:hover { background-color: #0bc698 !important; border-color: #0bc698 !important; color: white !important; }

                    /* Hover/focus on filter fields */
                    .custom-filter.float-select-wrap:hover .ant-select-selector,
                    .custom-filter.float-select-wrap:focus-within .ant-select-selector {
                        border-color: #1D1D1D !important; box-shadow: none !important;
                    }
                    .custom-filter.float-select-wrap:hover .ant-picker,
                    .custom-filter.float-select-wrap .ant-picker-focused {
                        border-color: #1D1D1D !important; box-shadow: none !important;
                    }
                    .custom-filter.float-select-wrap:hover label,
                    .custom-filter.float-select-wrap:focus-within label { color: #1D1D1D !important; }
                    .custom-filter.float-select-wrap:hover .ant-select-arrow,
                    .custom-filter.float-select-wrap:focus-within .ant-select-arrow { color: #1D1D1D !important; }
                    .custom-filter.float-select-wrap:hover .ant-picker-suffix div,
                    .custom-filter.float-select-wrap:focus-within .ant-picker-suffix div { background-color: #1D1D1D !important; }
                    .custom-filter.float-select-wrap:hover .ant-picker-suffix div i,
                    .custom-filter.float-select-wrap:focus-within .ant-picker-suffix div i { color: #fff !important; }

                    /* Table fixed layout - no scroll */
                    .listing-table { table-layout: fixed; width: 100%; min-width: 900px; }
                    .listing-table th:nth-child(1), .listing-table td:nth-child(1) { width: 13%; }
                    .listing-table th:nth-child(2), .listing-table td:nth-child(2) { width: 11%; }
                    .listing-table th:nth-child(3), .listing-table td:nth-child(3) { width: 12%; }
                    .listing-table th:nth-child(4), .listing-table td:nth-child(4) { width: 10%; }
                    .listing-table th:nth-child(5), .listing-table td:nth-child(5) { width: 10%; }
                    .listing-table th:nth-child(6), .listing-table td:nth-child(6) { width: 9%; }
                    .listing-table th:nth-child(7), .listing-table td:nth-child(7) { width: 11%; }
                    .listing-table th:nth-child(8), .listing-table td:nth-child(8) { width: 13%; }
                    .listing-table th:nth-child(9), .listing-table td:nth-child(9) { width: 8%; }
                    .listing-table th { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
                    .listing-table td { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
                    .listing-table-wrapper { overflow-x: auto; }
                    .table-body-wrapper { position: relative; }
                    .table-loader-overlay { position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: rgba(255,255,255,0.75); display: flex; align-items: center; justify-content: center; z-index: 10; min-height: 60px; }
                `}</style>

                <div className="d-flex align-items-center justify-content-end" style={{ padding: "0 0 12px 0" }}>
                  <div className="d-flex align-items-center gap-2 flex-wrap">
                    <div className={`float-select-wrap custom-filter ${statusFilter !== "all" ? "has-value" : ""}`} style={{ width: "200px", maxWidth: "200px" }}>
                      <label>Status</label>
                      <Select
                        allowClear
                        placeholder=""
                        value={statusFilter === "all" ? null : statusFilter}
                        onChange={(val) => setStatusFilter(val || "all")}
                        dropdownStyle={{ zIndex: 1050 }}
                      >
                        <Option value="all" label="All">All</Option>
                        <Option value="0" label="Pending">Pending</Option>
                        <Option value="1" label="Approved">Approved</Option>
                        <Option value="2" label="Disapproved">Disapproved</Option>
                        <Option value="3" label="Late-In">Late-In</Option>
                        <Option value="4" label="Absent">Absent</Option>
                      </Select>
                    </div>

                    <div className={`float-select-wrap custom-filter ${(dateRangeFilter && dateRangeFilter.length > 0) ? "has-value" : ""}`} style={{ width: "280px", maxWidth: "280px" }}>
                      <label>Leave Period</label>
                      <RangePicker
                        value={dateRangeFilter}
                        onChange={(val) => setDateRangeFilter(val)}
                        allowClear
                        separator=""
                        placeholder={['', '']}
                        suffixIcon={
                          <div style={{
                            backgroundColor: "#F4F4F4",
                            borderRadius: "6px",
                            width: "24px",
                            height: "24px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginRight: "-4px"
                          }}>
                            <i className="uil-schedule" style={{ color: "#A0A0A0", fontSize: "15px" }} />
                          </div>
                        }
                      />
                    </div>

                    <button
                      className="btn btn-dark eval-action-btn"
                      data-bs-toggle="modal"
                      data-bs-target="#offcanvasRightLeaves"
                      aria-controls="offcanvasRightLeaves"
                    >
                      <i className="uil-plus me-1"></i> Apply For Leave
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="row px-0 mt-2 d-flex flex-wrap align-items-center">
              <div className="col-auto mb-2">
                <div className="card" style={{ borderRadius: "0", boxShadow: "none", border: "1px solid #eff2f7", backgroundColor: "#fff" }}>
                  <div className="card-body px-3 py-2 d-flex align-items-center flex-wrap">
                    <h6 className="fw-bold mb-0 me-4 text-uppercase text-muted" style={{ fontSize: "12px", letterSpacing: "1px" }}>Leave Balance</h6>
                    {leaveBalances.length > 0 ? (
                      <div className="d-flex flex-wrap gap-2">
                        {leaveBalances.map((leave, index) => (
                          <div key={index} className="px-3 py-1 d-flex align-items-center" style={{ minWidth: "140px", justifyContent: "space-between", backgroundColor: "#f8f9fa", border: "1px solid #eff2f7" }}>
                            <span className="text-uppercase text-muted me-3" style={{ fontSize: "11px", fontWeight: "600", letterSpacing: "0.5px" }}>{leave.leave_type_name}</span>
                            <span className="fw-bold" style={{ fontSize: "14px", color: "#2c3e50" }}>
                              {leave.remaining_leaves} <span style={{ fontSize: "10px", fontWeight: "500", color: "#adb5bd" }}>{leave.unit}</span>
                            </span>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="text-muted small fst-italic">No leave balances available.</div>
                    )}
                  </div>
                </div>
              </div>

              <div className="col-auto mb-2">
                <div className="card" style={{ borderRadius: "0", boxShadow: "none", border: "1px solid #eff2f7", backgroundColor: "#fff" }}>
                  <div className="card-body px-3 py-2 d-flex align-items-center">
                    <h6 className="fw-bold mb-0 me-4 text-uppercase text-muted" style={{ fontSize: "12px", letterSpacing: "1px" }}>Total Absents
                      <Tooltip title="This shows your total cumulative absents.">
                        <i className="fa fa-info-circle ms-1" style={{ cursor: 'help', fontSize: '10px', color: '#000' }} />
                      </Tooltip>
                    </h6>
                    <div className="px-3 py-1 d-flex align-items-center" style={{ minWidth: "140px", justifyContent: "space-between", backgroundColor: "#fff5f5", border: "1px solid #fecaca" }}>
                      <span className="text-uppercase text-danger me-3" style={{ fontSize: "11px", fontWeight: "600", letterSpacing: "0.5px" }}>Absents</span>
                      <span className="fw-bold" style={{ fontSize: "14px", color: "#991b1b" }}>
                        {Math.max(absentCount, (DataForEmployee || []).reduce((acc, curr) => {
                          if (curr.status === 4 || curr.leave_type_name === "Absent Penalty") {
                            return acc + (Number(curr.totalleaves) || 0);
                          }
                          return acc;
                        }, 0))} <span style={{ fontSize: "10px", fontWeight: "500", color: "#f87171" }}>days</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row mt-3">
              <div className="col-lg-12 px-0">
                <div className="card" style={{ backgroundColor: "#fff", boxShadow: "none", borderRadius: 0, border: "none" }}>
                  <div className="card-body p-0">
                    <div className="listing-table-wrapper">
                      <table className="table mb-0 custom-table listing-table">
                        <thead>
                          <tr className="tableHeaderbg">
                            <th className="text-start ps-4">Leave Type</th>
                            <th className="text-start">Allowed Leaves</th>
                            <th className="text-start">Remaining Leaves</th>
                            <th className="text-start">Start Date</th>
                            <th className="text-start">End Date</th>
                            <th className="text-start">Total Leaves</th>
                            <th className="text-start">Status</th>
                            <th className="text-start">Action Taken By</th>
                            <th className="text-start pe-4">Action</th>
                          </tr>
                        </thead>
                      </table>
                      <div className="table-body-wrapper">
                        <table className="table mb-0 custom-table listing-table" style={{ marginTop: 0 }}>
                          <colgroup>
                            <col style={{ width: "13%" }} />
                            <col style={{ width: "11%" }} />
                            <col style={{ width: "12%" }} />
                            <col style={{ width: "10%" }} />
                            <col style={{ width: "10%" }} />
                            <col style={{ width: "9%" }} />
                            <col style={{ width: "11%" }} />
                            <col style={{ width: "13%" }} />
                            <col style={{ width: "8%" }} />
                          </colgroup>
                          <tbody>
                          {isloading ? <TableSkeleton cols={9} rows={6} /> : DataForEmployee.length > 0 ? (
                              PaginatedData.length > 0 ? (
                                PaginatedData.map((el, index) => (
                                  <tr key={shortid.generate()}>
                                    <td className="text-start ps-4">
                                      {el.leav_type !== null ? (el.leav_type.name === "Absent Penalty" ? "Absent" : el.leav_type.name) : "-"}
                                    </td>
                                    <td className="text-start">
                                      {(el.leave_type_name === "Absent Penalty" || el.leav_type?.name === "Absent Penalty" || el.leav_type?.name === "Absent") ? "N/A" : (el.leav_type?.allowed_leaves ?? "-")}
                                    </td>
                                    <td className="text-start">
                                      {(el.leave_type_name === "Absent Penalty" || el.leav_type?.name === "Absent Penalty" || el.leav_type?.name === "Absent") ? "N/A" : (el.leav_type?.remaining_leaves ?? "-")}
                                    </td>
                                    <td className="text-start">
                                      {el.status === 3 ? "N/A" : ((el.from_date && el.from_date !== "N/A" && moment(el.from_date).isValid())
                                        ? <span><i className="uil uil-calendar-alt me-1" style={{ color: "#0DDFAB", fontSize: "14px" }}></i> {moment(el.from_date).format("D, MMMM")}</span>
                                        : (el.leavedates && el.leavedates[0] && moment(el.leavedates[0], "DD-MM-YYYY").isValid()
                                          ? <span><i className="uil uil-calendar-alt me-1" style={{ color: "#0DDFAB", fontSize: "14px" }}></i> {moment(el.leavedates[0], "DD-MM-YYYY").format("D, MMMM")}</span>
                                          : "N/A"))}
                                    </td>
                                    <td className="text-start">
                                      {el.status === 3 ? "N/A" : ((el.to_date && el.to_date !== "N/A" && moment(el.to_date).isValid())
                                        ? <span><i className="uil uil-calendar-alt me-1" style={{ color: "#0DDFAB", fontSize: "14px" }}></i> {moment(el.to_date).format("D, MMMM")}</span>
                                        : (el.leavedates && el.leavedates[0] && moment(el.leavedates[0], "DD-MM-YYYY").isValid()
                                          ? <span><i className="uil uil-calendar-alt me-1" style={{ color: "#0DDFAB", fontSize: "14px" }}></i> {moment(el.leavedates[0], "DD-MM-YYYY").format("D, MMMM")}</span>
                                          : "N/A"))}
                                    </td>
                                    <td className="text-start">{el.totalleaves}</td>
                                    <td className="text-start">
                                      {el.status === 0 || el.status === null || el.status === undefined || el.status === "" ? (
                                        <span className="badge px-3" style={{ backgroundColor: "#fdfd96", color: "#856404", border: "1px solid #ced4da", borderRadius: "5px" }}>Pending</span>
                                      ) : el.status === 1 ? (
                                        <span className="badge px-3" style={{ backgroundColor: "#d4edda", color: "#155724", border: "1px solid #c3e6cb", borderRadius: "5px" }}>Approved</span>
                                      ) : el.status === 3 ? (
                                        <span className="badge px-3" style={{ backgroundColor: "#f2fffb", color: "#0bc698", border: "1px solid #b2ebf2", borderRadius: "5px" }}>Late-In</span>
                                      ) : el.status === 4 ? (
                                        <span className="badge px-3" style={{ backgroundColor: "#ffebee", color: "#c62828", border: "1px solid #ef9a9a", borderRadius: "5px" }}>Absent</span>
                                      ) : (
                                        <span className="badge px-3" style={{ backgroundColor: "#f8d7da", color: "#721c24", border: "1px solid #f5c6cb", borderRadius: "5px" }}>Disapproved</span>
                                      )}
                                    </td>
                                    <td className="text-start">
                                      {el.status === 3 || el.status === 4 ? "System" : (el?.approved_By?.name || "-")}
                                    </td>
                                    <td className="text-start pe-4">
                                      <Link
                                        to="#"
                                        className="cursor-pointer"
                                        onClick={() => handleViewReason(el.reason, (el.leav_type.name === "Absent Penalty" ? "Absent" : el.leav_type.name), el.from_date, el.to_date, el.totalleaves, el.leav_type.allowed_leaves, el.leav_type.remaining_leaves, el.status, (el.status === 3 || el.status === 4) ? "System" : el?.approved_By?.name, el.leavedates)}
                                      >
                                        <Tooltip title="View Details">
                                          <i className="uil-eye" style={{ color: "#0DDFAB", fontSize: "18px" }} />
                                        </Tooltip>
                                      </Link>
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="9" className="text-center py-4 text-muted">No Matching Records Found.</td>
                                </tr>
                              )
                          ) : !isloading ? (
                            <tr>
                              <td colSpan="9" className="text-center py-4 text-muted">Apply for your first leave.</td>
                            </tr>
                          ) : (
                            <tr><td colSpan="9" style={{ height: "60px" }}></td></tr>
                          )}
                          </tbody>
                        </table>
                      </div>

                      {filteredData.length > pageSize && (
                        <div className="d-flex justify-content-center mt-4">
                          <Pagination itemCount={filteredData.length} currentPage={currentPage} pageSize={pageSize} onPageChange={handelPageChange} />
                        </div>
                      )}

                      <div id="createCategoryModal" className="modal fade" tabIndex={-1} role="dialog">
                        <form>
                          <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content">
                              <div className="modal-header">
                                <h5 className="modal-title">User Leave</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" />
                              </div>
                              <div className="modal-body">
                                <div className="row">
                                  <div className="col-12 mb-3 d-flex" style={{ alignItems: "center" }}>
                                    <table className="table mb-0 table-striped">
                                      <thead>
                                        <tr className="tableHeaderbg">
                                          <th style={{ width: "80%" }}>Date</th>
                                          <th>Paid Leave</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {userLeavesList.map((es) => (
                                          <tr key={shortid.generate()}>
                                            <td className="tableset">{es.date}</td>
                                            <td className="tableset">
                                              {DataParser.userRoleTitle() === "HR" ? (
                                                <LeaveBadge item={es} api={LeaveApplicationService.userLeaveTypeUpdate} />
                                              ) : (
                                                es.typ === 1 ? <span className="btn btn-success btn-sm">Yes</span> : <span className="btn btn-danger btn-sm">No</span>
                                              )}
                                            </td>
                                          </tr>
                                        ))}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                         </form>
                      </div>

                      <div className="modal fade" id="reasonModal" tabIndex="-1" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered">
                          <div className="modal-content p-0" style={{ borderRadius: "12px", overflow: "hidden", border: "none", boxShadow: "0 10px 30px rgba(0,0,0,0.1)" }}>
                            <div className="modal-header border-0 px-4 py-3 bg-white pb-0">
                              <h5 className="modal-title fw-bold" style={{ color: "#1D1D1D", fontSize: "1.1rem" }}>Leave Details</h5>
                              <button type="button" className="btn-close shadow-none" data-bs-dismiss="modal" />
                            </div>
                            <div className="modal-body p-4 bg-white">
                              {isloading ? (
                                <div className="text-center py-5">
                                  <div className="spinner-border" role="status" style={{ color: "#0DDFAB", width: "2.5rem", height: "2.5rem" }}>
                                    <span className="visually-hidden">Loading...</span>
                                  </div>
                                </div>
                              ) : (
                                <div className="leave-details">
                                  {[
                                    ["Leave Type", <span className="fw-medium">{leavetypeText}</span>],
                                    ["Allowed Leaves", allowedleavesText],
                                    ["Remaining Leaves", leavebalanceText],
                                    ["From", statusText == 3 ? "N/A" : ((fromdateText && fromdateText !== "N/A" && moment(fromdateText).isValid()) ? moment(fromdateText).format("D, MMMM") : "N/A")],
                                    ["To", statusText == 3 ? "N/A" : ((todateText && todateText !== "N/A" && moment(todateText).isValid()) ? moment(todateText).format("D, MMMM") : "N/A")],
                                    ["Total Days", <span className="fw-bold text-dark">{noofdaysText}</span>],
                                    [
                                      "Status",
                                      statusText === 0 || statusText === null || statusText === "" ? (
                                        <span className="badge px-3" style={{ backgroundColor: "#fdfd96", color: "#856404", border: "1px solid #ced4da", borderRadius: "5px" }}>Pending</span>
                                      ) : statusText === 1 ? (
                                        <span className="badge px-3" style={{ backgroundColor: "#d4edda", color: "#155724", border: "1px solid #c3e6cb", borderRadius: "5px" }}>Approved</span>
                                      ) : statusText === 3 ? (
                                        <span className="badge px-3" style={{ backgroundColor: "#f2fffb", color: "#0bc698", border: "1px solid #b2ebf2", borderRadius: "5px" }}>Late-In</span>
                                      ) : statusText === 4 ? (
                                        <span className="badge px-3" style={{ backgroundColor: "#ffebee", color: "#c62828", border: "1px solid #ef9a9a", borderRadius: "5px" }}>Absent</span>
                                      ) : (
                                        <span className="badge px-3" style={{ backgroundColor: "#f8d7da", color: "#721c24", border: "1px solid #f5c6cb", borderRadius: "5px" }}>Disapproved</span>
                                      )
                                    ],
                                    ["Action Taken By", <span className="text-muted">{(statusText === 1 || statusText === 2) ? actiontakenbyText : "-"}</span>],
                                    ["Reason", <div style={{ fontSize: "0.9rem", color: "#666" }}>{reasonText}</div>],
                                  ].map(([label, value], idx, arr) => (
                                    <div key={idx} className={`mb-3 d-flex flex-wrap align-items-start ${idx === arr.length - 1 ? "" : "border-bottom"} pb-2`}>
                                      <div style={{ minWidth: "140px", fontWeight: "600", color: "#495057", fontSize: "0.9rem" }}>{label}:</div>
                                      <div className="flex-grow-1" style={{ color: "#212529", lineHeight: "1.5", wordBreak: "break-word", fontSize: "0.9rem" }}>{value}</div>
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Leaves;
